
import MembersDep from '@/components/SelectEmployee/MembersDep';

export default {
  name: 'XhStrucUserCell', // 新建 struc-user-cell
  components: {
    MembersDep: MembersDep
  },
  props: {
    // 员工和 部门
    placeholder: {
      type: String,
      default: '请选择'
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    strucs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Object,
      default: function _default() {
        return {
          users: [],
          strucs: []
        };
      }
    },
    max: {
      type: Number,
      default: 2
    },
    /** 索引值 用于更新数据 */
    index: Number,
    /** 包含数据源 */
    item: Object
  },
  data: function data() {
    return {
      showPopover: false,
      dataUsers: [], // 关联的时候展示name 编辑的时候展示realname
      dataStrucs: []
    };
  },

  computed: {
    showDataValue: function showDataValue() {
      if (this.allData.length > this.max) {
        return this.allData.slice(0, this.max);
      }
      return this.allData;
    },
    allData: function allData() {
      var dataUsers = this.dataUsers || [];
      var dataStrucs = this.dataStrucs || [];
      return dataUsers.concat(dataStrucs);
    }
  },
  watch: {
    value: function value(val) {
      this.dataUsers = val.users;
      this.dataStrucs = val.strucs;
    },
    users: function users(val) {
      this.dataUsers = val;
    },
    strucs: function strucs(val) {
      this.dataStrucs = val;
    }
  },
  created: function created() {
    if (this.value) {
      this.dataUsers = this.value.users;
      this.dataStrucs = this.value.strucs;
    } else {
      this.dataUsers = this.users || [];
      this.dataStrucs = this.strucs || [];
    }
  },

  methods: {
    popoverSubmit: function popoverSubmit(users, strucs) {
      this.dataUsers = users;
      this.dataStrucs = strucs;

      this.$emit('value-change', {
        index: this.index,
        value: { users: users, strucs: strucs }
      });
    },
    popoverShow: function popoverShow(val) {
      this.showPopover = val;
    },


    /** 删除 */
    deleteItem: function deleteItem(item, index) {
      if (item.id && item.type == 'user') {
        this.dataUsers.splice(index, 1);
      } else {
        this.dataStrucs.splice(index - this.dataUsers.length, 1);
      }

      this.$emit('value-change', {
        index: this.index,
        value: { users: this.dataUsers, strucs: this.dataStrucs }
      });
    },


    /** 聚焦动作 */
    focusClick: function focusClick() {
      this.$emit('focus');
    }
  }
};